/**
 * Redux reducer for the GlobalLoading component
 * Manages loading state for application-wide loading indicator
 */
import { createSlice } from '@reduxjs/toolkit';
import { LoadingState } from '../../interfaces/connected-components/loading';

/**
 * Initial state for the loading reducer
 * Loading overlay is initially hidden
 */
const initialState: LoadingState = {
  isVisible: false,
};

/**
 * Redux slice for loading state management
 * Provides reducers for showing and hiding the loading overlay
 */
export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    /**
     * Sets the loading state to visible
     *
     * @param state - Current loading state
     */
    startGlobalLoading: (state) => {
      state.isVisible = true;
    },
    /**
     * Sets the loading state to hidden
     *
     * @param state - Current loading state
     */
    finishGlobalLoading: (state) => {
      state.isVisible = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startGlobalLoading, finishGlobalLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
